import { Alert, Box, Button, CircularProgress, Typography } from "@mui/material";
import { useTranslate } from "../i18n";

export function PageLoading() {
  return <Box sx={{ display: "grid", placeItems: "center", minHeight: 280 }}><CircularProgress /></Box>;
}

export function PageError({ message, onRetry }: { message: string; onRetry: () => void }) {
  const __ = useTranslate();
  return <Alert severity="error" action={<Button color="inherit" onClick={onRetry}>{__("ลองใหม่")}</Button>}>{message}</Alert>;
}

export function EmptyState({ title, description }: { title: string; description: string }) {
  return <Box sx={{ textAlign: "center", py: 9, color: "text.secondary" }}>
    <Typography variant="h6" color="text.primary">{title}</Typography>
    <Typography>{description}</Typography>
  </Box>;
}
